import { AuthData } from '@domain/auth/model.ts'

export type RequestMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'

export class ApiError extends Error {
  public status: number
  public message: string

  constructor(status: number, message: string) {
    super(message)

    this.status = status
    this.message = message
  }
}

export type ReqConfig<TResponse = unknown> = {
  signal?: AbortSignal
  headers?: Record<string, string>
  transformResponse?: (response: TResponse) => TResponse
  query?: any
  apiUrl?: string
  skipAuthorization?: boolean
  disableAutoSnakeCase?: boolean
  sendRawBody?: boolean
  shouldShowErrorToast: boolean
  shouldRedirectToRoot: boolean
  definedErrorMessage?: string
  bodyTransformer?: (body: any) => any
  autoContentType?: boolean
  encodeValuesOnly?: boolean
  sendDecodedQuery?: boolean
  getRawResponse?: boolean
  credentials?: RequestCredentials
  skipFingerprint?: boolean
}

export type UseApiOptions = {
  isAuthEnabled?: boolean
}

export type FlowAccumulator = {
  apiUrl: string
  reqConfig: Partial<ReqConfig>
  method: string
  response?: Response
  body?: BodyInit
  bodyTransformed?: BodyInit
  error?: Error
  tokens?: AuthData
  isUnauthorized?: boolean
  isBanned?: boolean
  sessionFingerprint?: string
}
export type Param = { [P in string]: string | Blob }

export type HandleUnauthorizedFn = (options: {
  shouldRedirectToRoot?: boolean
  shouldShowErrorToast?: boolean
}) => Promise<void>
export type HandleBannedFn = () => Promise<void>
export type RequestTokenFn = () => AuthData
